//const api_end_point = "https://tcagenda2023.s.cmshelp.dk/AgendaList/";
const api_end_point = "https://conferenceapiagenda.s.cmshelp.dk/AgendaList/";
//const api_end_point = "https://localhost:44353/AgendaList/";
export default {
    api_end_point: api_end_point,
    initial_load_api: api_end_point + "GetAllAgendaDataAll?eventName=ges-2026",
    category_list_api: api_end_point + "GetCategoryListAll?eventName=ges-2026",
    date_list_api: api_end_point + "GetDateListAll?eventName=ges-2026",
    agenda_detail_api: api_end_point + "GetAgendaDataByIdAll?eventName=ges-2026",
    user_detail_api: api_end_point + "GetAgendaUserByUserId" 
};


